<script>
    import {mapState} from "vuex";
    import optionInput from "@/components/Admin/option-input.vue";

    export default {
        name: "Admin options sidebar",
        components: {
            optionInput
        },
        props: {
            isEdit: Boolean, // мод редактирования или нет
            currentTab: {
                type: String,
                default: ''
            }, // текущая страница, например products
            options: {
                type: Array,
                required: true,
                default: []
            }, // опции, которые будем создавать
            keys: {
                type: Object
            },
            isAllowSave: {
                type: Boolean
            },
            pageInputs: {
                type: Array
            },
            defaultValues: {
                type: Object,
                default: {}
            }
        },
        data: () => ({
            placeholders: {
                products: {
                    "Обычная цена": "0",
                    "Цена по скидке": "0",
                    "Закупочная цена": "0",
                    "Дата создания": "дд.мм.гг",
                    "Команда": "Например, «Барселона»",
                    "Сезон": "гггг/гггг",
                },
                pages: {
                    "URL": "Уникальная ссылка"
                }
            },
            types: {
                "Тип продукта": "select",
                "Тип": "select",
                "Состояние": "select",
                "Размер": "select",
                "Бренд": "select",
                "Автор": "select",
                "Клиент (пользователь)": "select",
                "Цвет": "select",
                "Обычная цена": "price",
                "Цена по скидке": "price",
                "Закупочная цена": "price",
                "Команда": "name",
                "Сезон": "season",
                "Статус": 'select'
            },
            models: {},
            errors: {},
            stores: {
                "Бренд": 'brands',
                "Тип продукта": 'productTypes',
                "Тип": 'pageTypes',
                "Цвет": 'colors',
                "Состояние": 'conditions',
                "Автор": 'users',
                "Клиент (пользователь)": "users",
                "Размер": 'sizes',
                "Статус": 'statuses'
            }
        }),
        computed: {
            checkErrors() {
                let isError = false

                this.isAllowSave ? isError = false : isError = true

                for (let e in this.keys) {
                    if (!this.errors[this.keys[e]]) {
                        isError = true
                    } else if (this.errors[this.keys[e]] === 'true') {
                        isError = true
                    }
                }

                return isError
            }
        },
        methods: {
            goBack() {
                this.$router.go(-1)
            },
            setPlaceholder(elem) {
                for (let el in this.placeholders[this.currentTab]) {
                    if (el === elem) {
                        return this.placeholders[this.currentTab][el]
                    }
                }
            },
            setInputModels() {
                for (let elem in this.keys) {
                    // this.models[this.keys[elem]] = ""

                    if (this.keys[elem] === 'colors') {
                        this.errors[this.keys[elem]] = 'false'
                    }

                    if (this.isAllowSave) {
                        for (let el of this.pageInputs) {
                            if (el === this.keys[elem]) {
                                this.errors[this.keys[elem]] = 'false'
                            }
                        }
                    }
                }
            },
            saveItem(e) {
                if (this.defaultValues) {
                    for (let key in this.defaultValues) {
                        if (!this.models[this.keys[key]]) {
                            this.models[this.keys[key]] = this.defaultValues[key]
                        }
                    }
                }

                if (e.srcElement.tagName === "SPAN") {
                    if (e.srcElement.parentNode.classList.contains("disabled")) {
                        return;
                    }
                }
                if (e.srcElement.classList.contains("disabled")) {
                    return
                }
                this.$emit('update:options', this.models)
            },
            inputSetChange(value, input) {
                this.models[input] = value;
            },
            setError(value, input) {
                this.errors[input] = value
            }
        },
        mounted() {
            this.setInputModels()
        },
        updated() {
            this.setInputModels()
        },
        watch: {
            defaultValues: {
                handler(newValue, oldValue) { // поменяли порядок аргументов
                    if (
                        typeof newValue === 'object' && newValue !== null &&
                        typeof oldValue === 'object' && oldValue !== null &&
                        JSON.stringify(newValue) !== JSON.stringify(oldValue)
                    ) {
                        this.$forceUpdate();
                    }
                },
                immediate: true,
                deep: true
            }
        }
    }
</script>

<template>
    <div class="options-sidebar sidebar">
        <div class="buttons">
            <div :class="['save-btn', 'btn', checkErrors ? 'disabled' : '']" @click="saveItem($event)">
                <span>Сохранить</span>
            </div>
            <div class="cancel-btn btn" @click.native="goBack">
                <div>
                    <span>Отмена</span>
                </div>
            </div>
        </div>
        <div class="options-block">
            <div v-for="(elem, ind) in options" :class="['option-elem', keys[elem] || 'none-elem']">
                    <option-input
                        v-if="defaultValues[elem] || !isEdit"
                        :head-text="elem"
                        :inputType="types[elem]"
                        :input-placeholder="setPlaceholder(elem)"
                        :model-variable=keys[elem]
                        :select-store="stores[elem]"
                        :defaultValue.sync="defaultValues[elem]"
                        @update:modelValue="inputSetChange"
                        @update:isError="setError"
                    ></option-input>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
@use '~@/assets/styles/vars' as *;

div.options-sidebar {
        background: $light-gray;
        width: 40%;
        height: 100%;
        padding-top: 40px;
        padding-bottom: 40px;

        display: flex;
        flex-direction: column;
        gap: 30px
    }

    .save-btn {
        background: $black;
        width: 100%;
        padding: 8.8px 13px;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;

        transition: $transition;
    }

    .save-btn.disabled {
        background: $gray;
        cursor: not-allowed;
    }

    .save-btn.disabled span {
        color: $hard-gray;
        opacity: 0.6;
    }

    .cancel-btn {
        background: $gray;
        width: 100%;
        padding: 8.8px 13px;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
    }

    .buttons {
        display: flex;
        align-items: flex-start;
        gap: 2%;
    }

    .buttons > div {
        height: 100%;
    }

    .save-btn span, .save-btn a {
        color: $white;
        font-size: 14px;
        font-weight: 400;
    }

    .cancel-btn span, .cancel-btn a {
        color: $black;
        font-size: 14px;
        font-weight: 400;
    }

    .options-block {
        background: $white;
        padding: 30px;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        gap: 15px
        //box-shadow: $shadow;
    }

    .options-block .none-elem {
        display: none;
    }

    .option-elem {
        display: flex;
        flex-direction: column;
        gap: 7px;
    }
</style>
